export default __webpack_public_path__ + "static/media/DINNextLTW23-Bold.c7f93a32.woff";